import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeIsSummaryOpened, setPendingDownloadAfterContact, setPopupState } from '../../model/configuratorSlice';
import { PopupState } from '../../model/constants';

const CheckForContactBeforeDownloadPopup = () => {
    const { popupState } = useSelector(state => state.configurator);
    const dispatch = useDispatch();

    const isOpened = popupState === PopupState.CheckForContactBeforeDownload;

    if (!isOpened) return null;

    const handleNo = () => {
        dispatch(setPopupState(PopupState.None));
        dispatch(changeIsSummaryOpened(false));
    };

    const handleYes = () => {
        dispatch(setPendingDownloadAfterContact(true));
        dispatch(setPopupState(PopupState.ContactUs));
    };

    return (
      <div className="contact-us-popup opened">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button className="background opened" type="button" onClick={handleNo} />
        <div className="panel opened narrow">
          <div className="header">Descargar Resumen</div>
          <div className="sub-header">
            Para poder descargar el resumen, debe dejar sus datos de contacto.
            ¿Desea facilitarnos sus datos?
          </div>
          <div className="container-buttons-row">
            <button className="popup-secondary-button" type="button" onClick={handleNo}>
              <span>No, gracias</span>
            </button>
            <button className="popup-primary-button" type="button" onClick={handleYes}>
              <span>Sí, dejar mis datos</span>
            </button>
          </div>
        </div>
      </div>
    );
};

export default CheckForContactBeforeDownloadPopup;
